import { render, staticRenderFns } from "./DatosDeuda.vue?vue&type=template&id=4b1f1916&scoped=true&"
import script from "./DatosDeuda.vue?vue&type=script&lang=js&"
export * from "./DatosDeuda.vue?vue&type=script&lang=js&"
import style0 from "./DatosDeuda.vue?vue&type=style&index=0&id=4b1f1916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f1916",
  null
  
)

export default component.exports